<template>
  <div class="sim-type-data summary-list">
    <div class="summary-row">
      <div class="label">
        <slot name="lblSimType"><abbr title="Subscriber Identity Module">SIM</abbr> Typ</slot>
      </div>
      <div class="value">
        {{ simType === SimTypes.simCardCode ? SimTypes.simCardLabel : SimTypes.eSimLabel }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { SimTypes } from '@/helper/SimTypes'

export default {
  name: 'SimTypeSummary',
  data() {
    return {
      SimTypes
    }
  },
  computed: {
    ...mapGetters('activation/personalData', ['simType'])
  }
}
</script>
